module.exports = __webpack_public_path__ + "img/ewm_2.0e110bb3.png";